import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
	ChangeDetectorRef,
} from '@angular/core';
import {
	CarrierFeedback,
	CarrierNotes,
	ContactsTable,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	Owner,
	ProjectsTable,
	RestService,
	TruckLane,
	TruckSearchTable,
	DATE_MDY,
	BrokerLaneDetails,
	ProjectDTO,
	INTEGRATION_TYPE,
} from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { SharedService } from '@service/shared/shared.service';
import { UrlService } from '@service/url/url.service';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { CarrierContactsComponent } from '../../contact-details/carrier-contacts/carrier-contacts.component';
import {
	CARGOCHIEF_KEYS,
	COPY_TO_CLIPBOARD_MSGS,
	MIN_PAGE_CONTAINER_WIDTH,
	MIN_WIDTH_CONTAINER_CLASS,
} from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UserCarrierMapHelperService } from '@service/userCarrierMapHelper/user-carrier-map-helper.service';
import { IntegrationService } from '@service/integration/integration.service';
import { NotesService } from '@service/notesService/notes.service';
import { CarrierToProjectsMap } from '@domain/interface/carrier-to-projects-map';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { environment } from '@environment/environment';
import { NoteListComponent } from '@notes/note-list/note-list.component';
import { ProductsService } from '@service/products/products.service';
import { BaseComponent } from '@shared/base/base.component';
import { CarrierVettingService } from '@service/carrier-vetting/carrier-vetting.service';
import { SHOW_IN_NETWORK_LOGO, SHOW_ONBOARD_CARRIER_LINK } from '@shared/utils/in-network';
import { Router } from '@angular/router';
import { HaulpayService } from '@service/haulpay/haulpay.service';

@Component({
	selector: 'app-lane-details',
	templateUrl: './lane-details.component.html',
	styleUrls: ['./lane-details.component.scss'],
})
export class LaneDetailsComponent extends BaseComponent implements OnInit {
	@Input() carrierLaneData: any = null;
	@Input() recentFeedback: any = null;
	@Input() recentFeedbackList: Array<CarrierFeedback> = null;
	@Input() showBackText: boolean = true;

	@Input() totalNumberOfProjects = null;
	@Input() carrierProjectMap: CarrierToProjectsMap;
	@Input() openedMatch: TruckSearchTable = null;
	@Input() lanePricing: any = null;
	@Input() isLoadingProjectsList: boolean = false;
	@Input() projectsNextPage: boolean = false;
	@Input() projectsViewList: Array<ProjectsTable> = null;
	@Input() showProjectsTab: boolean = false;

	@Output() closeLaneDetails = new EventEmitter<any>();
	@Output() loadMoreProjects: EventEmitter<any> = new EventEmitter();

	contactList: ContactsTable[] = null;
	capacitySearch: TruckSearchTable = null;

	@ViewChild(NoteListComponent)
	notesListComponent: NoteListComponent;
	COPY_TO_CLIPBOARD_MSGS = COPY_TO_CLIPBOARD_MSGS;

	@ViewChild(CarrierContactsComponent)
	carrierContactsComponent: CarrierContactsComponent;

	carrierData = {
		id: null,
		businessName: null,
	};
	totalNumberOfNotes: any;
	totalNumberOfTasks: any;
	IS_TASKS_ENABLED: boolean = false;
	userCarrierMap: any = null;
	isLoadingUserCarrierMap: boolean = false;
	isLoadingContactsList: boolean = false;
	isAdminOrOwner: boolean = false;
	userAssignedToCarrier: number = null;

	IS_PROJECTS_ENABLED: boolean = false;
	IS_ACCOUNT_TYPE_CARRIER: boolean = false;
	IS_HAZMAT_ENABLED: boolean = false;
	IS_TEAMS_CAPACITY_ENABLED: boolean = false;

	// for handling carrier actions when carrier see his own profile
	isCarrierLoggedIn: boolean = false;
	incorrectContactInfoEnabled: boolean = true;
	LANES_CURRENT_PAGE = 0;
	LANES_PAGE_SIZE = 20;
	lanesList: TruckLane[] = null;
	lanesLength = null;
	inputConfig: any = {
		origin: true,
		trailerType: true,
		destination: true,
	};
	carrier: any = null;

	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	DATE_MDY = DATE_MDY;
	SHOW_IN_NETWORK_LOGO = SHOW_IN_NETWORK_LOGO;
	SHOW_ONBOARD_CARRIER_LINK = SHOW_ONBOARD_CARRIER_LINK;
	CARRIER_QUALITY_ENABLED!: boolean;

	// edit carrier
	carrierHQ: string = '';
	carrierDetails: UntypedFormGroup;
	initialCarrierForm: any;
	isUpdatingCarrier: boolean = false;
	selectedLane: BrokerLaneDetails = null;
	isCarrierVettingIntegrationEnabled!: boolean;
	environment = environment;

	constructor(
		public utilService: UtilService,
		private sharedService: SharedService,
		private urlService: UrlService,
		private restService: RestService,
		private segmentWrapper: SegmentWrapperService,
		public cargochief: Cargochief,
		private userCarrierMapHelperService: UserCarrierMapHelperService,
		public integrationService: IntegrationService,
		private notesService: NotesService,
		private _formBuilder: UntypedFormBuilder,
		public accountSettings: AccountSettingsService,
		public productsService: ProductsService,
		public carrierVettingService: CarrierVettingService,
		public haulpayService: HaulpayService,
		private router: Router,
		private cdRef: ChangeDetectorRef
	) {
		super();
		this.sharedService.getCarrierFullProfileEvent().subscribe((data: any) => {
			if (IS_NOT_NULL_OR_UNDEFINED(data)) {
				this.cargochief.removeItem(CARGOCHIEF_KEYS.IS_FULL_PROFILE_OPENED);
				this.closeLaneDetails.emit();
			}
		});
		this.CARRIER_QUALITY_ENABLED = this.accountSettings.CARRIER_QUALITY;
	}

	ngOnInit() {
		this.IS_TASKS_ENABLED = this.productsService.TASKS;
		this.IS_PROJECTS_ENABLED = this.productsService.PROJECT_CARRIERS;
		this.IS_ACCOUNT_TYPE_CARRIER = this.utilService.isAccountTypeCarrier();
		this.IS_HAZMAT_ENABLED = this.accountSettings.HAZMAT || this.productsService.HAZMAT;
		this.IS_TEAMS_CAPACITY_ENABLED =
			environment.TEAMS_CAPACITY && this.accountSettings.TEAMS_CAPACITY;
		this.isAdminOrOwner = this.utilService.isUserRoleAdmin() || this.utilService.isUserRoleOwner();
		this.integrationService.getMyCarrierPacketsToken();
		this.selectedLane = null;
		this.isCarrierVettingIntegrationEnabled =
			this.integrationService.isCarrierVettingIntegrationEnabled();
	}

	ngOnChanges() {
		if (
			IS_NOT_NULL_OR_UNDEFINED(this.carrierLaneData) &&
			IS_NOT_NULL_OR_UNDEFINED(this.carrierLaneData.lane)
		) {
			this.capacitySearch = this.carrierLaneData.lane;
			if (
				IS_NULL_OR_UNDEFINED(this.carrierLaneData.contactList) &&
				IS_NULL_OR_UNDEFINED(this.contactList) &&
				!this.isLoadingContactsList
			) {
				this.getContactsList();
			}
			if (IS_NOT_NULL_OR_UNDEFINED(this.carrierLaneData.contactList)) {
				this.contactList = this.carrierLaneData.contactList;
			}
			this.carrierData.id = this.carrierLaneData.lane.carrierId;
			this.carrierData.businessName = this.carrierLaneData.lane.businessName;
			if (!this.isLoadingUserCarrierMap && this.productsService.ASSIGN_CARRIERS) {
				this.getAssignee();
			}
			this.updateCarrierActions();
			super.setDefaultPageWidth(
				'carrier profile sidenav',
				MIN_WIDTH_CONTAINER_CLASS.CAPACITY_SEARCH,
				MIN_PAGE_CONTAINER_WIDTH.CARRIER_PROFILE_SIDENAV,
				'carrier_profile_contaier'
			);
			this.cdRef.detectChanges();
		}
	}

	updateCarrierActions() {
		this.isCarrierLoggedIn = false;
		this.incorrectContactInfoEnabled = true;
		this.carrier = null;
		if (
			this.utilService.isAccountTypeCarrier() &&
			this.cargochief.CARRIER?.id &&
			this.cargochief.CARRIER.id === this.carrierData.id
		) {
			this.isCarrierLoggedIn = true;
			this.incorrectContactInfoEnabled = false;
			this.carrier = this.cargochief.CARRIER;
			this.getCarrierLanes();
			this.setCarrierDetailsForm();
		}
	}

	notesAdded(event: CarrierNotes) {
		this.notesService.sendNotesAddedEvent(event);
	}

	getContactsList() {
		this.isLoadingContactsList = true;
		this.contactList = null;
		const contactsUrl = this.urlService.contactsUrl(this.capacitySearch.carrierId);
		this.restService.GET(contactsUrl).subscribe(
			(result) => {
				result['carrier'] = this.getCarrierInfo();
				this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.contact_requested, result);
				this.contactList = result['data'];
				this.isLoadingContactsList = false;
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot fetch contact list.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.contactList = [];
				this.isLoadingContactsList = false;
			}
		);
	}

	getCarrierInfo() {
		return {
			businessName: this.capacitySearch.businessName,
			mc: this.capacitySearch.firmMc,
			dot: this.capacitySearch.firmDot,
			carrierId: this.capacitySearch.carrierId,
		};
	}

	openContactDialog(contact: ContactsTable) {
		this.carrierContactsComponent.openContactDialog(contact);
	}

	recruitLanes() {
		const payload = {
			lane: this.carrierLaneData.lane,
		};
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_recruit_lanes_carrier,
			payload
		);
		this.utilService.showSnackbar(
			'We have received your request.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
	}

	setAssignee(user: Owner) {
		if (IS_NOT_NULL_OR_UNDEFINED(user)) {
			if (
				IS_NULL_OR_UNDEFINED(this.userCarrierMap) ||
				(IS_NOT_NULL_OR_UNDEFINED(this.userCarrierMap) &&
					this.userCarrierMap.assigneeId != user.userId)
			) {
				this.addUserCarrierMap(user);
			}
		} else if (IS_NULL_OR_UNDEFINED(user) && IS_NOT_NULL_OR_UNDEFINED(this.userCarrierMap)) {
			this.deleteUserCarrierMap();
		}
	}

	addUserCarrierMap(user: Owner) {
		const payload = this.userCarrierMapHelperService.createPayload(
			user.userId,
			this.capacitySearch.carrierId,
			false
		);
		const url = this.urlService.userCarrierMap();
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.userCarrierMap = result.data;
				this.utilService.showSnackbar('User Assigned.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.sharedService.sendCarrierAssignedEvent({
					deleted: false,
					carrierId: this.capacitySearch.carrierId,
					assigneeName: user.name,
					userCarrierMap: result.data,
				});
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to set Assignee. Please try again.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	deleteUserCarrierMap() {
		const payload = {
			userCarrierMapIDs: [this.userCarrierMap.id],
		};
		const url = this.urlService.userCarrierMap();
		this.restService.DELETE(url, payload).subscribe(
			(result) => {
				this.userCarrierMap = null;
				this.utilService.showSnackbar('Assignee removed.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.sharedService.sendCarrierAssignedEvent({
					deleted: true,
					carrierId: this.capacitySearch.carrierId,
				});
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to delete Assignee. Please try again.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	getAssignee() {
		this.isLoadingUserCarrierMap = true;
		let userCarrierMapList: any = this.cargochief.getItem(CARGOCHIEF_KEYS.USER_CARRIER_MAPS);
		if (IS_NOT_EMPTY(userCarrierMapList)) {
			userCarrierMapList = JSON.parse(userCarrierMapList);
			this.userCarrierMap = userCarrierMapList.find(
				(userCarrierMap) => userCarrierMap.carrierId == this.capacitySearch.carrierId
			);
		} else {
			this.userCarrierMap = null;
		}
		this.isLoadingUserCarrierMap = false;
	}

	onboardCarrier() {
		let integrationType = this.integrationService.getEnabledCarrierVettingIntegration();
		this.showMyCarrierEmailConfirmation(integrationType);
	}

	showMyCarrierEmailConfirmation(integrationType: INTEGRATION_TYPE) {
		let payload: any = this.utilService.getUserDataForSegmentEvent();
		payload.search = this.capacitySearch;
		payload.page = 'carrier_full_profile';
		this.integrationService.showMyCarrierEmailConfirmation(
			this.capacitySearch.businessName,
			this.capacitySearch.firmDot,
			this.capacitySearch.carrierId,
			payload,
			null,
			null,
			integrationType
		);
	}

	getCarrierLanes() {
		this.lanesList = null;
		const url = this.urlService.getLanesList();
		const payload = {
			page: this.LANES_CURRENT_PAGE,
			pageSize: this.LANES_PAGE_SIZE,
			carrierId: this.cargochief.CARRIER.id,
		};
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.lanesList = result['data'];
				this.lanesLength = result.numberOfResults;
			},
			(error) => {
				this.lanesList = [];
				this.utilService.showSnackbar(
					'Cannot fetch carrier lanes.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
			}
		);
	}

	laneAdded(lanes: any) {
		this.lanesList = lanes.concat(this.lanesList);
		this.lanesList = this.lanesList.slice(0);
	}

	getAddressOnChange($event, LocationCtrl) {
		if (LocationCtrl === 'hq') {
			if (IS_NOT_EMPTY($event.city)) {
				this.carrierDetails.controls['city'].setValue($event.city);
			} else {
				this.carrierDetails.controls['city'].setValue(null);
			}

			if (IS_NOT_EMPTY($event.state)) {
				this.carrierDetails.controls['state'].setValue($event.state);
			} else {
				this.carrierDetails.controls['state'].setValue(null);
			}

			if (IS_NOT_EMPTY($event.country)) {
				this.carrierDetails.controls['country'].setValue($event.country);
			} else {
				this.carrierDetails.controls['country'].setValue(null);
			}

			if (IS_NOT_EMPTY($event.zip)) {
				this.carrierDetails.controls['postcode'].setValue($event.zip);
			} else {
				this.carrierDetails.controls['postcode'].setValue(null);
			}

			if (IS_NOT_NULL_OR_UNDEFINED($event.latitude) && $event.latitude != '') {
				this.carrierDetails.controls['latitude'].setValue($event.latitude);
			} else {
				this.carrierDetails.controls['latitude'].setValue(null);
			}

			if (IS_NOT_NULL_OR_UNDEFINED($event.longitude) && $event.longitude != '') {
				this.carrierDetails.controls['longitude'].setValue($event.longitude);
			} else {
				this.carrierDetails.controls['longitude'].setValue(null);
			}
		}
	}

	setCarrierDetailsForm() {
		this.carrierDetails = this._formBuilder.group({
			businessName: [this.cargochief.CARRIER.businessName, Validators.required],
			dot: [this.cargochief.CARRIER.dot],
			mc: [this.cargochief.CARRIER.mc],
			city: this.cargochief.CARRIER.city,
			state: this.cargochief.CARRIER.state,
			country: this.cargochief.CARRIER.country,
			drivers: this.cargochief.CARRIER.drivers,
			powerUnits: this.cargochief.CARRIER.powerUnits,
			phone: this.cargochief.CARRIER.phone,
			trailerType: this.cargochief.CARRIER.defaultTrailerType,
			postcode: this.cargochief.CARRIER.postcode,
			latitude: this.cargochief.CARRIER.latitude,
			longitude: this.cargochief.CARRIER.longitude,
		});

		this.initialCarrierForm = Object.assign({}, this.carrierDetails.value);
	}

	updateCarrierDetails() {
		this.isUpdatingCarrier = true;
		const url = this.urlService.updateCarrier();
		this.setUpdatedCarrierData();
		this.restService.POST(url, this.carrier).subscribe(
			(result) => {
				this.updatedCarrier();
			},
			(error) => {
				if (error.status == 200) {
					this.updatedCarrier();
				} else {
					this.utilService.showSnackbar(
						'Error occured while updating carrier details.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
					this.isUpdatingCarrier = false;
				}
			}
		);
	}

	updatedCarrier() {
		this.isUpdatingCarrier = false;
		this.utilService.showSnackbar(
			'Carrier details updated Successfully.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
		this.initialCarrierForm = Object.assign({}, this.carrierDetails.value);
	}

	setUpdatedCarrierData() {
		this.carrier.businessName = this.carrierDetails.get('businessName').value;
		this.carrier.dot = IS_NOT_EMPTY(this.carrierDetails.get('dot').value)
			? this.carrierDetails.get('dot').value
			: null;
		this.carrier.mc = IS_NOT_EMPTY(this.carrierDetails.get('mc').value)
			? this.carrierDetails.get('mc').value
			: null;
		this.carrier.city = this.carrierDetails.get('city').value;
		this.carrier.state = this.carrierDetails.get('state').value;
		this.carrier.country = this.carrierDetails.get('country').value;
		this.carrier.drivers = this.carrierDetails.get('drivers').value;
		this.carrier.powerUnits = this.carrierDetails.get('powerUnits').value;
		this.carrier.phone = this.carrierDetails.get('phone').value;
		this.carrier.defaultTrailerType = this.carrierDetails.get('trailerType').value;
		this.carrier.postcode = this.carrierDetails.get('postcode').value;
		this.carrier.latitude = this.carrierDetails.get('latitude').value;
		this.carrier.longitude = this.carrierDetails.get('longitude').value;
	}

	isCarrierFormDisabled() {
		return (
			this.carrierDetails.invalid ||
			JSON.stringify(this.initialCarrierForm) == JSON.stringify(this.carrierDetails.value)
		);
	}

	updateSelectedLane(lane: BrokerLaneDetails) {
		if (IS_NOT_NULL_OR_UNDEFINED(this.selectedLane)) {
			if (
				this.selectedLane.carrierId === lane.carrierId &&
				this.selectedLane.laneId === lane.laneId
			) {
				this.selectedLane = null;
			} else {
				this.selectedLane = lane;
			}
		} else {
			this.selectedLane = lane;
		}
	}

	projectAdded(project: ProjectDTO) {
		this.router.navigate([`projects/project_details/${project.id}`]);
	}
}
